import type { MockedResponse } from '@apollo/client/testing';
import { media } from '../../pages/product/[productSlug]/[externalProductId]/components/ProductImageGallery/mockData';
import { GetMiniPdpProductDocument, type GetMiniPdpProductQuery, type GetMiniPdpProductQueryVariables } from './getMiniPdpProduct';
import type { MiniPdpProduct } from './MiniPdpModal.types';
import { mockPaymentOptions, mockProduct } from './mockData';
type MockProduct = NonNullable<GetMiniPdpProductQuery['shopProductBySkuId']>;
type MockProductWithVariant = MockProduct & {
  variantBySkuId: NonNullable<MockProduct['variantBySkuId']>;
};
export const getMiniPdpProductData = (product: MiniPdpProduct = mockProduct): {
  shopProductBySkuId: MockProductWithVariant;
} => ({
  shopProductBySkuId: {
    __typename: 'ShopProduct',
    id: `mini-product-${product.sku}`,
    name: product.name,
    brand: {
      name: product.brand ?? 'Brand'
    },
    description: 'A versatile style to wear with your everyday favorites.',
    variantBySkuId: {
      __typename: 'ShopProductVariant',
      id: product.sku,
      sku: product.sku,
      color: {
        name: product.colorName ?? 'Olive'
      },
      size: {
        name: product.size ?? 'M'
      },
      inseam: product.inseam ? {
        name: product.inseam
      } : null,
      media: [...(product.heroMedia ? [{
        altText: product.heroMedia.alt,
        originalSrc: `${product.heroMedia.baseUrl}${product.heroMedia.mediaPath}`,
        contentGroup: 'flat_image',
        position: 0
      }] : []), ...media.map((image, index) => ({
        altText: image.altText,
        originalSrc: image.originalSrc,
        contentGroup: image.group,
        position: index + 1
      }))],
      detailGroups: [{
        key: 'materials_care',
        details: [{
          label: 'Materials',
          value: '98% cotton, 2% elastane'
        }, {
          label: 'Care',
          value: 'Machine wash cold. Tumble dry low.'
        }]
      }, {
        key: 'product_details',
        details: [{
          label: 'Fit',
          value: 'True to size'
        }]
      }],
      price: {
        currency: 'USD',
        value: 10000
      },
      priceMarkdown: null,
      priceStickerLabel: null,
      priceType: null,
      installmentPayments: {
        label: mockPaymentOptions.installmentPaymentsLabel ?? ''
      },
      buyNowPayLaterHelpContent: mockPaymentOptions.buyNowPayLaterHelpContent
    }
  }
});
export const getMiniPdpProductMock = (product: MiniPdpProduct = mockProduct): MockedResponse<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables> => ({
  request: {
    query: GetMiniPdpProductDocument,
    variables: {
      skuId: product.sku
    }
  },
  result: {
    data: getMiniPdpProductData(product)
  },
  maxUsageCount: Number.POSITIVE_INFINITY
});